import React                from 'react';
import * as S               from '../../LifePlan/Home/styles';
import * as GV              from '../../../global/globalVariables';
import midia2               from '../../../assets/midia2.png';

function TrailerExpensesAI() {

    function buttonMidia2() {
        window.open('https://www.youtube.com/watch?v=iLeTkNA6M_s', '_blank');
    }

    function linkSite() {
        window.open('https://www.kodasware.com/', '_blank');
        return false;
    }

    return ( 
        <>
        <S.MidiaContainer>
            <S.MidiaItem><S.MidiaButton onClick={buttonMidia2}><img src={midia2} alt=''></img></S.MidiaButton></S.MidiaItem>
        </S.MidiaContainer>

        <S.ContainerCopy><span>{GV.COPYWRITE_DATE} &copy;&nbsp;<a href="#" onClick={linkSite}>{GV.COPYWRITE_NAME}</a>&nbsp;&nbsp;All rights reserved.</span></S.ContainerCopy>
        </>
     );
}

export default TrailerExpensesAI;